module.exports = __webpack_public_path__ + "img/mastercard.a7f2eb22.svg";